<div class="preview-container">
    <div #previewMap id="preview-map" class="preview-map"></div>
</div>
